// Standalone demo page that doesn't use AuthContext
import { Component } from '@/components/ui/authentication-card';

export function StandaloneDemo() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-8 mb-12">
          <h1 className="text-4xl font-bold text-gray-900">🔐 Authentication Card Component</h1>
          <p className="text-xl text-gray-600">Beautiful, modern login form with advanced features</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full">Password Toggle</span>
            <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full">Form Validation</span>
            <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full">Remember Me</span>
            <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full">Modern Design</span>
          </div>
        </div>

        <div className="flex justify-center">
          <Component />
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">This is a demo of the shadcn/ui authentication card component</p>
        </div>
      </div>
    </div>
  );
}
